import * as _ from 'lodash';

import { TrackingEvents, TrackingEventsWithPayloads, PayloadProperties } from './event-definitions';

const gtmParamIdMap = {
    [PayloadProperties.PAGE_TYPE]: '1',
    [PayloadProperties.ELEMENT_NAME]: '2',
    [PayloadProperties.BRAND]: '4',
    [PayloadProperties.ACCESS_TYPE_REQUESTED]: '7',
    [PayloadProperties.FILTER_SEASON]: '8',
    [PayloadProperties.FILTER_CHANNELS]: '10',
    [PayloadProperties.FILTER_COLOR]: '11',
    [PayloadProperties.FILTER_EXPIRY_DATE]: '12',
    [PayloadProperties.FILTER_SIZE]: '13',
    [PayloadProperties.FILTER_SEARCH_INPUT]: '14',
    [PayloadProperties.FILTER_TARGET_GROUP]: '15',
    [PayloadProperties.FILTER_TYPE]: '16',
    [PayloadProperties.FILTER_DISCOUNT]: '17',
    [PayloadProperties.FILTER_MIN_STOCK]: '18',
    [PayloadProperties.FILTER_BRAND]: '19',
    [PayloadProperties.BRAND_PLAN]: '20',
    [PayloadProperties.CONTENT_TYPE]: '21',
    [PayloadProperties.CLICK_URL]: '22',
    [PayloadProperties.POST_NAME]: '24',
    [PayloadProperties.PROMOTED_BRAND_NAME]: '25',
    [PayloadProperties.SEARCH_RESULTS]: '26',
    [PayloadProperties.SEARCH_TERM]: '27',
    [PayloadProperties.BRAND_CONNECT_WITH_NOTE]: '28',
    [PayloadProperties.USER_ROLE]: '29',
    [PayloadProperties.POSITION_FEED]: '30',
    [PayloadProperties.FEATURED_BRAND]: '31',
    [PayloadProperties.FEATURED_BRAND_SOURCE]: '32'
};

const gtmEventDefaults = {
    [TrackingEvents.NEWSFEED_CONTENT_CLICKED]: {
        [PayloadProperties.CLICK_URL]: null,
        [PayloadProperties.PAGE_TYPE]: 'newsfeed'
    },
    [TrackingEvents.BRAND_SELECTED]: {},
    [TrackingEvents.FILTER_INTERACTION]: {},
    [TrackingEvents.BRAND_ACCESS_CLICK_CONNECT]: {
        [PayloadProperties.PAGE_TYPE]: 'brand_access'
    },
    [TrackingEvents.BRAND_ACCESS_REQUEST_CONFIRMED]: {
        [PayloadProperties.PAGE_TYPE]: 'brand_access'
    },
    [TrackingEvents.SEARCH]: {},
    [TrackingEvents.BUTTON_CLICK]: {}
};

function convertPayloadPropertyToGtmFormat(key: PayloadProperties, value: any) {
    const paramId = gtmParamIdMap[key];

    return { [`parameter${paramId}`]: key, [`value${paramId}`]: value };
}

export function convertTrackingPayloadToGtmPayload<T extends TrackingEvents>(
    eventName: T,
    payload: TrackingEventsWithPayloads[T]
) {
    const fullPayloadWithDefaults = _.defaults(payload, gtmEventDefaults[eventName as TrackingEvents]);

    const gtmPayload = Object.keys(fullPayloadWithDefaults).reduce(
        (paramsAndValues, property: PayloadProperties) => ({
            ...paramsAndValues,
            ...convertPayloadPropertyToGtmFormat(property, payload[property])
        }),
        {
            event_name: eventName
        }
    );

    return gtmPayload;
}
